import api from "../utils/axiosInstance";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const selectTemplate = (userId, templateId, token) =>
  axios.post(`${API_BASE}/api/v1/templates/select`, null, {
    params: { userId, templateId },
    headers: { Authorization: `Bearer ${token}` },
  });

export const getUserSelectedTemplate = (userId, token) =>
  axios.get(`${API_BASE}/api/v1/templatesselected`, {
    params: { userId },
    headers: { Authorization: `Bearer ${token}` },
  });

export const createTemplate = async (template) => {
  const token = localStorage.getItem("token");
  const apiUrl = `${API_BASE}/api/v1/templates/create`;

  try {
    const response = await api.post(apiUrl, template, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.data?.success) {
      return {
        success: true,
        message: response?.data?.message,
        data: null,
      };
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: null,
      };
    }
  } catch (error) {
    return {
      result: "error",
      message: "Something went wrong, please try again !",
      data: null,
    };
  }
};

export const getTemplates = async () => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const url = `${apiKey}/api/v1/templates/list`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or just `return response` if you want status etc.
  } catch (error) {
    console.error("API error:", error);
    throw error;
  }
};

export const updateTemplate = async (id, template) => {
  const token = localStorage.getItem("token");
  const apiUrl = `${API_BASE}/api/v1/templates/${id}`;

  try {
    const response = await api.put(apiUrl, template, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.success) {
      return {
        success: true,
        message: response.message,
        data: response.data,
      };
    } else {
      return {
        success: false,
        message: response.message,
        data: response.data,
      };
    }
  } catch (error) {
    return {
      result: "error",
      message: "Something went wrong, please try again !",
      data: null,
    };
  }
};

export const deleteTemplate = async (id) => {
  const token = localStorage.getItem("token");
  try {
    let response = await api.delete(
      `${API_BASE}/api/v1/templates/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response?.data?.success) {
      return {
        success: true,
        message: response?.data?.message,
        data: null,
      };
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: null,
      };
    }
  } catch (error) {
    return {
      result: "error",
      message: "Something went wrong, please try again !",
      data: null,
    };
  }
};

export const getTemplate = async (id) => {
  const apiKey = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = `${apiKey}/api/v1/templates/view/${id}`;
  const token = localStorage.getItem("token");

  try {
    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response?.data?.success) {
      return {
        success: true,
        message: response?.data?.message,
        data: response?.data,
      };
    } else {
      return {
        success: false,
        message: response?.data?.message,
        data: null,
      };
    }
  } catch (error) {
    return {
      result: "error",
      message: "API error:" + error,
      data: null,
    };
  }
};
